import "./globals.css";
import type { Metadata } from "next";
import ClientLayout from "./ClientLayout";
import { ToastContainer } from "react-toastify";
import { Geist, Geist_Mono, Inter } from "next/font/google";
import AuthProvider from "@/components/auth/AuthProvider";

const geistSans = Geist({
  variable: "--font-geist-sans",
  subsets: ["latin"],
});

const geistMono = Geist_Mono({
  variable: "--font-geist-mono",
  subsets: ["latin"],
});
const inter = Inter({
  subsets: ["latin"],
  variable: "--font-inter",
});

export const metadata: Metadata = {
  title: "Pioneer Alpha Ltd",
  description: "Generated by Pioneer Alpha Ltd",
};

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html lang="en">
      <body
        className={`${geistSans.variable} ${geistMono.variable} ${inter.variable} antialiased`}
      >
        <AuthProvider>
          {" "}
          <ClientLayout>{children}</ClientLayout>
        </AuthProvider>
        <ToastContainer />{" "}
      </body>
    </html>
  );
}
